import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { CountdownTimer } from "@/components/CountdownTimer";
import { MarqueeRibbon } from "@/components/Marquee";
import { WhyWeRun } from "@/components/WhyWeRun";
import { CeoSection } from "@/components/CeoSection";
import { EveryMile } from "@/components/EveryMile";
import { Pricing } from "@/components/Pricing";
import { RegisterWidget } from "@/components/RegisterWidget";
import { Timeline } from "@/components/Timeline";
import { Volunteers } from "@/components/Volunteers";
import { Sponsors } from "@/components/Sponsors";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-hope-cream font-body text-hope-ink antialiased">
      <Header />
      <main>
        <Hero />
        <CountdownTimer />
        <MarqueeRibbon />
        <WhyWeRun />
        <CeoSection />
        <EveryMile />
        <Pricing />
        <RegisterWidget />
        <Timeline />
        <Volunteers />
        <Sponsors />
        <Faq />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
